var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoomSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "124px",
    viewBox: "0 0 124 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "50773D67-7F3B-44BE-BBD3-0C9A882D91F3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location---Empty",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-658.000000, -358.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stack",
    transform: "translate(204.000000, 164.000000)",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empty-State",
    transform: "translate(224.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stack",
    transform: "translate(40.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "zoom-split",
    transform: "translate(192.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,120 L95.1724138,95.1724138",
    id: "Shape",
    stroke: "#00B5E1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#002C8B",
    cx: 49.6551724,
    cy: 49.6551724,
    r: 49.6551724
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5862069,41.3793103 C20.6896552,29.7931034 29.7931034,20.6896552 41.3793103,17.5862069",
    id: "Shape",
    stroke: "#00B5E1"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomSplit);
export default __webpack_public_path__ + "static/media/zoom-split.d11e77db.svg";
export { ForwardRef as ReactComponent };